import { styled } from '@acko-tech/building-blocks.ui.common';

export const Wrapper = styled.div`
    display: flex;
    cursor: pointer;
`;

export const IconFlex = styled.div`
    display: flex;
    flex: 1;
    align-items: center;
`;

export const Title = styled.div`
    display: flex;
    flex: 5;
    align-items: center;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    color: #040222;
`;
